import { baseClient } from './baseRequest';

export type LabelsApiClient = {
  searchCollectionLabels: (query: string) => Promise<string[]>;
};

const labelsApiClient: LabelsApiClient = {
  searchCollectionLabels: async (query: string) => {
    return baseClient.get<string[]>({
      url: `/studio/labels/collection?query=${query}`,
    });
  },
};

export default labelsApiClient;
